import { Container, Dropdown, Image, Nav, Navbar, NavDropdown, Modal, Button } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";
import { useState } from "react";

export default function TopBar({ user, userDoc, onLogout }) {
	const navigate = useNavigate();
	const [showIncompleteModal, setShowIncompleteModal] = useState(false);
	const [imgError, setImgError] = useState(false);

	const goToProfile = () => navigate("/");

	const isProfileComplete = !!((userDoc?.photoMeta || userDoc?.photoURL) && userDoc?.displayName);

	const handleProtectedNav = (e, path) => {
		if (!isProfileComplete) {
			e.preventDefault();
			setShowIncompleteModal(true);
		} else {
			navigate(path);
		}
	};

	return (
		<>
			<Navbar className="custom-navbar" expand={false}>
				<Container>
					<Navbar.Brand as={Link} to="/" className="fw-bold me-3 d-flex align-items-center gap-2">
						<div
							className="d-block d-sm-none"
							style={{ position: "relative", width: "40px", height: "40px", flexShrink: 0 }}
						>
							<svg
								viewBox="0 0 40 40"
								xmlns="http://www.w3.org/2000/svg"
								style={{ width: "100%", height: "100%", marginTop: "2px" }}
							>
								<path
									d="M20 34 C20 34 4 24 4 13 C4 8 8 4 13 4 C16.5 4 19 6 20 8 C21 6 23.5 4 27 4 C32 4 36 8 36 13 C36 24 20 34 20 34Z"
									fill="#009ab6"
								/>
							</svg>
							<span
								style={{
									position: "absolute",
									inset: 0,
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									color: "white",
								}}
							>
								G2K
							</span>
						</div>
						<span className="d-none d-sm-block">Get2Know Social</span>
					</Navbar.Brand>

					{!user && (
						<Nav>
							<Nav.Link as={Link} to="/about" className="white">
								<i className="bi bi-info-circle me-1"></i> About
							</Nav.Link>
						</Nav>
					)}

					{user && (
						<>
							<Nav className="me-auto">
								<NavDropdown title="Events" id="basic-nav-dropdown" className="custom-dropdown-float">
									<NavDropdown.Item onClick={(e) => handleProtectedNav(e, "/events")}>
										<i className="bi bi-calendar-event me-2"></i> All Events
									</NavDropdown.Item>
									<NavDropdown.Item onClick={(e) => handleProtectedNav(e, "/my-matches")}>
										<i className="bi bi-arrow-through-heart me-2"></i> My Matches
									</NavDropdown.Item>
									<NavDropdown.Item as={Link} to="/about">
										<i className="bi bi-info-circle me-2"></i> About Get2Know
									</NavDropdown.Item>
								</NavDropdown>
							</Nav>

							<div className="d-flex align-items-center">
								<div className="mx-3">
									<span className="d-none d-sm-block">Hello {user.displayName}!</span>
								</div>
								<Dropdown align="end">
									<Dropdown.Toggle as="div" id="profile-dropdown" style={{ cursor: "pointer" }}>
										{user.photoURL && !imgError ? (
											<Image
												src={user.photoURL}
												alt="User Profile"
												roundedCircle
												style={{ width: "40px", height: "40px", objectFit: "cover", overflow: "hidden" }}
												onError={() => setImgError(true)}
											/>
										) : (
											<i className="bi bi-person-circle" style={{ fontSize: "1.5rem", color: "#aaa" }}></i>
										)}
									</Dropdown.Toggle>
									<Dropdown.Menu>
										<Dropdown.Item onClick={goToProfile}>
											<i className="bi bi-person-circle me-2"></i>View Profile
										</Dropdown.Item>
										<Dropdown.Item onClick={onLogout}>
											<i className="bi bi-box-arrow-right me-2"></i>Logout
										</Dropdown.Item>
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</>
					)}
				</Container>
			</Navbar>

			<Modal show={showIncompleteModal} onHide={() => setShowIncompleteModal(false)} centered>
				<Modal.Header closeButton>
					<Modal.Title>Complete Your Profile</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<p>
						<i className="bi bi-person-exclamation me-2 text-warning" style={{ fontSize: "1.5rem" }}></i>
						Please add a profile photo and your name before viewing events or matches.
					</p>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={() => setShowIncompleteModal(false)}>
						Cancel
					</Button>
					<Button
						className="my-btn"
						onClick={() => {
							setShowIncompleteModal(false);
							navigate("/");
						}}
					>
						Go to Profile
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
}
